import { getDocumentKeywords } from "./readinessScoreUtils";
import type { TInvestorReadinessAssessment } from "./types";

/**
 * Check if a text contains any of the keywords
 */
function containsKeywords(text: string, keywords: string[]): boolean {
  const lowerText = text.toLowerCase();
  return keywords.some((keyword) => lowerText.includes(keyword.toLowerCase()));
}

/**
 * Get relevant feedback (gaps and recommendations) for a specific document type
 *
 * @param documentName - The name of the document/data type
 * @param assessment - The investor readiness assessment data
 * @returns Object containing filtered gaps and recommendations
 */
export function getRelevantFeedback(
  documentName: string,
  assessment: TInvestorReadinessAssessment
): {
  gaps: string[];
  recommendations: string[];
} {
  const keywords = getDocumentKeywords(documentName);

  // Filter gaps/weaknesses that are relevant to this document type
  const relevantGaps = (assessment.gaps_or_weaknesses ?? []).filter((gap) => containsKeywords(gap, keywords));

  // Filter recommendations that are relevant to this document type
  const relevantRecommendations = (assessment.recommendations ?? []).filter((rec) => containsKeywords(rec, keywords));

  return {
    gaps: relevantGaps,
    recommendations: relevantRecommendations,
  };
}
